export default "__VITE_ASSET__DfURNFr0__"